import {
  PASSWORD_STRENGTH_PASSWORD_CHANGED,
  PASSWORD_STRENGTH_PASSWROD_CONFIRMATION_CHANGED,
} from './PasswordStrengthConstants';

export const updatePassword = password => ({
  type: PASSWORD_STRENGTH_PASSWORD_CHANGED,
  payload: password,
});

export const updatePasswordConfirmation = password => ({
  type: PASSWORD_STRENGTH_PASSWROD_CONFIRMATION_CHANGED,
  payload: password,
});



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/PasswordStrength/PasswordStrengthActions.js